export default "__VITE_ASSET__Di6t6BSV__"